/* global modForm */
import { trackFormSubmissionFlow } from '../../helpers';
/**
 * Switch form submitting state
 * @param {String} submitState - Indicates current status for form submit
 */
export function switchFormSubmitState(submitState) {
	trackFormSubmissionFlow({ inSwitchFormSubmitState: true });
	if (submitState === 'submitting') {
		trackFormSubmissionFlow({ formSubmitting: true });
		modForm.opts.form.classList.add(modForm.opts.formSubmittingCls);
	} else if (submitState === 'submitted') {
		trackFormSubmissionFlow({ formSubmitted: true });
		modForm.opts.form.classList.add(modForm.opts.formSubmittedCls);
	} else if (submitState === 'error') {
		trackFormSubmissionFlow({ formSubmitError: true });
		modForm.opts.form.classList.add(modForm.opts.formSubmitErrorCls);
	} else {
		modForm.opts.form.classList.remove(
			modForm.opts.formSubmittingCls,
			modForm.opts.formSubmittedCls,
			modForm.opts.formSubmitErrorCls
		);
		document.body.classList.remove('submitted');
	}
}
